import { useCallback } from 'react';
import {
  getLyrraOneRegionalValue,
  type LyrraOneRegionalNamespace,
} from '@/lib/lyrraone-regional-content';
import { usePublicRegionStore } from '@/stores/public-region.store';
import { useLanguageStore } from '@/stores/language.store';

export function useLyrraOneRegional(namespace: LyrraOneRegionalNamespace) {
  const region = usePublicRegionStore((state) => state.region);
  const setRegion = usePublicRegionStore((state) => state.setRegion);
  const language = useLanguageStore((state) => state.language);

  const tx = useCallback(
    (key: string) => getLyrraOneRegionalValue(namespace, region, key, language),
    [namespace, region, language],
  );

  return { tx, region, setRegion, isMorocco: region === 'ma', language };
}
